import React              from 'react';
import { TableBody }      from '@mui/material';
import Table              from '@mui/material/Table';
import TableContainer     from '@mui/material/TableContainer';
import { useTranslation } from 'react-i18next';
import TableRow           from '@mui/material/TableRow';
import TableCell          from '@mui/material/TableCell';
import TableHead          from '@mui/material/TableHead';
import {Title}            from '../../../typography/Title';

const CartSubTotals = ({ subtotals }) => {
	const { t } = useTranslation();

	return (
		<TableContainer>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell align='center' colSpan={2}>
							<Title>
								{t('cart_sub_totals')}
							</Title>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>

					<TableRow>
						<TableCell>{t('cart_sub_total_cart')}</TableCell>
						<TableCell align='right'>{subtotals.regular.display}</TableCell>
					</TableRow>

					<TableRow>
						<TableCell>{t('cart_sub_total_shipping')}</TableCell>
						<TableCell align='right'>{subtotals.shipping.display}</TableCell>
					</TableRow>

					<TableRow>
						<TableCell>{t('cart_sub_total_discount')}</TableCell>
						<TableCell align='right'>{subtotals.discount.display}</TableCell>
					</TableRow>

					<TableRow>
						<TableCell>{t('cart_sub_total_other_tax')}</TableCell>
						<TableCell align='right'>{subtotals.tax.display}</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default CartSubTotals;